import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { QuotationFormValues } from "../../../types";
import { QUOTATION_FORM_I18N_PREFIX, QUOTATION_SUMMARY_FIELDS } from "../data";
import { useStyles } from "./styles";

type Props = {
  formValues: QuotationFormValues;
};

const formatCurrency = (value: string) => {
  if (!value || value === "0") {
    return "₪0";
  }

  if (value.startsWith("₪")) {
    return value;
  }

  return `₪${value}`;
};

const SummaryMetrics = ({ formValues }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.summaryCard}>
      <Box className={styles.summaryGrid}>
        {QUOTATION_SUMMARY_FIELDS.map((config, index) => (
          <Box key={String(config.field)} className={styles.summaryMetric}>
            <Typography className={styles.summaryLabel}>
              {t(config.labelKey)}
            </Typography>
            <Typography className={styles.summaryValue}>
              {formatCurrency(formValues[config.field] as string)}
            </Typography>
            {index === 0 ? (
              <Typography className={styles.profitText}>
                {t(`${QUOTATION_FORM_I18N_PREFIX}.PROFIT`, {
                  amount: formValues.profitAmount,
                  percent: formValues.profitPercent,
                })}
              </Typography>
            ) : null}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SummaryMetrics;
